import React from 'react';
import { Line } from 'react-konva';
import PropTypes from 'prop-types';
import COLORS from 'utils/constants/colors';
const { GREY_01 } = COLORS;

const DrawLine = ({ dotted, points, dash, ...props }) => {
  return (
    <Line
      points={points}
      {...(dotted ? { dash } : {})}
      stroke={GREY_01}
      {...props}
    />
  );
};
DrawLine.propTypes = {
  dotted: PropTypes.bool,
  dash: PropTypes.array,
  points: PropTypes.array,
  props: PropTypes.object,
};

export default DrawLine;
